<template>
  <div>

    <h2 class="card-inside-title">
      {{ formData.label }} ({{formData.key }}) <small>{{optionalOrNot(formData.required)}}</small>
    </h2>
    <select
        class="form-control show-tick"
        v-model="$store.state.workflowStore.workflowsS[actionCount].api.design.forms[dropdownIndex].value"
    >
      <option value="" selected disabled>
        종류를 선택해주세요.
      </option>
      <option
          v-for="(code, index) in codeList"
          :key="index"
          :value="code"
      >
        {{ code }}
      </option>
    </select>
</div>

</template>

<script>

export default {
  components: {},
  props : ['formData','actionCount', 'dropdownIndex'],
  data() {
    return{
      codeList : [],

    }
  },
  computed: {

  },


  methods: {

    optionalOrNot(val){
      if(val == 0){
        return "선택"
      } else {
        return "필수"
      }
    },




  },
  mounted() {
    console.log("userEditorDropdownType.mounted")
    console.log(this.formData)

    // var list = []

    if(this.formData.dropdownSource != null){
      this.codeList = []
      console.log(this.formData.dropdownSource.codeSource.indexOf("\""))

      if(this.formData.dropdownSource.codeSource.indexOf("\"") > -1){
        this.formData.dropdownSource.codeSource = JSON.parse(this.formData.dropdownSource.codeSource)
      }


      for(var i = 0; i < this.formData.dropdownSource.codeSource.length; i++){
          var key = this.formData.dropdownSource.codeSource[i]
        this.codeList.push(key)

      }
    }


  },
  created(){
    console.log("userEditorDropdownType.created")

    console.log(this.formData)




  }
};
</script>


